import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function JoinByCode() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [game, setGame] = useState<'mafia' | 'zayac' | 'bunker' | 'alias'>('mafia');
  return (
    <GameLayout>
      <span className="label">/ Войти по коду</span>
      <h1 style={{ fontFamily: 'Oswald', fontWeight: 600, fontSize: 64, lineHeight: 1.02, margin: '12px 0 24px', letterSpacing: '-.015em' }}>
        Есть код комнаты?
      </h1>
      <p style={{ maxWidth: 480, color: 'var(--ink-dim)', fontSize: 16, lineHeight: 1.5, margin: '0 0 32px' }}>
        Выберите игру и введите короткий код, который вам дали (например, BK7M4Q).
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const c = code.trim().toUpperCase();
          if (!c) return;
          navigate(game === 'bunker' ? `/bunker/${c}` : game === 'zayac' ? `/zayac/${c}` : game === 'alias' ? `/alias/${c}` : `/room/${c}`);
        }}
        style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', maxWidth: 420 }}
      >
        <select
          className="text-input game-select"
          value={game}
          onChange={(event) => setGame(event.target.value as 'mafia' | 'zayac' | 'bunker' | 'alias')}
          aria-label="Игра"
        >
          <option value="mafia">Мафия</option>
          <option value="zayac">Заяц</option>
          <option value="bunker">Бункер</option>
          <option value="alias">Alias</option>
        </select>
        <input
          className="text-input"
          style={{ flex: 1, minWidth: 200 }}
          placeholder="ABCD1"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          maxLength={6}
          autoCapitalize="characters"
        />
        <button className="btn-primary lg" type="submit" disabled={!code.trim()}>
          Войти →
        </button>
      </form>
      <style>{`
        .text-input { background: var(--bg2); border: 1px solid var(--line-strong); border-radius: var(--radius-btn); color: var(--ink); padding: 14px 16px; font-family: 'JetBrains Mono', monospace; font-size: 20px; letter-spacing: 0.2em; outline: none; text-transform: uppercase; }
        .text-input:focus { border-color: var(--accent); }
        .game-select { font-size: 12px; letter-spacing: .08em; text-transform: none; flex: 0 0 130px; }
        @media (max-width: 520px) { .game-select { flex-basis: 100%; } }
      `}</style>
    </GameLayout>
  );
}
